// These are the basic settings for ALL opal text styles
// Certain faces have customizations atop this (other files in this folder)
export const opalBase = {
    title5xl: {
        fontSize: 4.375,
        lineHeight: 5.25,
        letterSpacing: 0,
        weight: 500,
    },
    title4xl: {
        fontSize: 3.5,
        lineHeight: 3.875,
        letterSpacing: 0,
        weight: 500,
    },
    title3xl: {
        fontSize: 2.5,
        lineHeight: 3.125,
        letterSpacing: 0,
        weight: 500,
    },
    title2xl: {
        fontSize: 1.75,
        lineHeight: 2.1875,
        letterSpacing: 0,
        weight: 500,
    },
    titleXl: {
        fontSize: 1.375,
        lineHeight: 1.75,
        letterSpacing: 0,
        weight: 500,
    },
    titleLg: {
        fontSize: 1.25,
        lineHeight: 1.625,
        letterSpacing: 0,
        weight: 500,
    },
    titleMd: {
        fontSize: 1.125,
        lineHeight: 1.5,
        letterSpacing: 0,
        weight: 500,
    },
    titleSm: {
        fontSize: 1,
        lineHeight: 1.375,
        letterSpacing: 0,
        weight: 500,
    },
    titleXs: {
        fontSize: 0.875,
        lineHeight: 1.25,
        letterSpacing: 0,
        weight: 500,
    },
    bodyLg: {
        fontSize: 1.25,
        lineHeight: 1.625,
        letterSpacing: 0,
        weight: 500,
    },
    bodyMd: {
        fontSize: 1,
        lineHeight: 1.375,
        letterSpacing: 0,
        weight: 500,
    },
    bodySm: {
        fontSize: 0.875,
        lineHeight: 1.25,
        letterSpacing: 0,
        weight: 500,
    },
    bodyXs: {
        fontSize: 0.75,
        lineHeight: 1.25,
        letterSpacing: 0,
        weight: 500,
    },
    buttonLg: {
        fontSize: 1.125,
        lineHeight: 1.5,
        letterSpacing: 0,
        weight: 500,
    },
    buttonMd: {
        fontSize: 1,
        lineHeight: 1.375,
        letterSpacing: 0,
        weight: 500,
    },
    buttonSm: {
        fontSize: 0.875,
        lineHeight: 1.25,
        letterSpacing: 0,
        weight: 500,
    },
};
//# sourceMappingURL=base.js.map